module.exports = __webpack_public_path__ + "static/media/quickstat.404c5dff.png";